import { useEffect, useState } from "react";
import { makeRequest } from "../makeRequest";

const useFetch = (url) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();
    let isMounted = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await makeRequest.get(url, {
          signal: abortController.signal
        });

        if (!isMounted) return;

        const statusCode = response?.data?.code;

        if (statusCode >= 400) {
          throw {
            code: statusCode,
            message: response?.data?.message || 'An error occurred'
          };
        }

        setData(response.data);

      } catch (err) {
        if (!isMounted) return;

        const errorCode = err?.code || err?.response?.status;
        const errorMessage = err?.message || 'An unexpected error occurred';

        setError({ code: errorCode, message: errorMessage });

        if ([401, 403].includes(errorCode)) {
          handleAuthError();
        }

        if (err.code === "ERR_NETWORK") {
          setError({
            code: "NETWORK_ERROR",
            message: "Unable to connect to the server. Please check your connection."
          });
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      isMounted = false;
      abortController.abort();
    };
  }, [url]);

  const handleAuthError = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return {
    data,
    loading,
    error,
    isError: !!error,
    isLoading: loading
  };
};

export default useFetch;
